import BaseInput from "Components/Base/BaseInput";
import BaseButton from "Components/Base/BaseButton";
import TableContainer from "Components/Base/BaseTable";
import { useEffect, useMemo, useState } from "react";
import { checkStatusCodeSuccess, notFound } from "Components/constants/Common";
import { RiSearchLine } from "react-icons/ri";
import {
  graphOfStatistics,
  dashboardStatistics,
  listOfTopCustomers,
} from "Api/Dashboard";
import {
  CLEAR_LABEL,
  CUSTOMER_NAME,
  LAST_PURCHASE,
  LAST_PURCHASE_ACCESS_KEY,
  TOP_CUSTOMER_LABEL,
  TOTAL_AMOUNT,
  TOTAL_AMOUNT_ACCESS_KEY,
  TOTAL_CUSTOMER_LABEL,
  TOTAL_ORDER_LABEL,
  TOTAL_PRODUCTS_LABEL,
  TOTAL_PURCHASES,
  TOTAL_PURCHASES_ACCESS_KEY,
  TOTAL_QUANTITY_LABEL,
} from "Components/constants/Dashboard";
import { NameKey, submitLabel } from "Components/constants/Role";
import { useFormik } from "formik";
import moment from "moment";
import { getGreeting } from "Components/constants/layout";
import { StatisticsCharts } from "./StatisticsChart";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import CountUp from "react-countup";
import { TopCustomersChart } from "./TopCustomerChart";

const DashboardCrm = () => {
  document.title = "Dashboard";

  const [loader, setLoader] = useState<boolean>(false);
  const [btnLoader, setBtnLoader] = useState<boolean>(false);
  const [topCustomerData, setTopCustomerData] = useState<Array<any>>([]);
  const [customPageSize, setCustomPageSize] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalNumberOfRows, setTotalNumberOfRows] = useState(0);

  const [totalOrder, setTotalOrder] = useState(0);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [totalCustomer, setTotalCustomer] = useState(0);
  const [totalProducts, setTotalProducts] = useState(0);
  const [chartData, setChartData] = useState<any>([]);

  const formik = useFormik({
    initialValues: {
      startDate: "",
      endDate: "",
    },
    onSubmit: (values) => {
      if (values.startDate || values.endDate) {
        setBtnLoader(true);
      }
      const payload: any = {};

      if (values.startDate) {
        payload.startDate = values.startDate;
      }
      if (values.endDate) {
        payload.endDate = values.endDate;
      }

      if (Object.keys(payload).length > 0) {
        fetchDashboardStatisticsData(payload);
        fetchTopCustomerData(payload);
        fetchChartData(payload);
      }
    },
  });

  const handleClear = () => {
    formik.resetForm();
    if (formik.values.startDate || formik.values.endDate) {
      fetchDashboardStatisticsData({});
      fetchTopCustomerData({});
      fetchChartData({});
    }
  };

  const topCustomerColumns = useMemo(
    () => [
      {
        header: CUSTOMER_NAME,
        accessorKey: NameKey,
        enableColumnFilter: false,
      },
      {
        header: TOTAL_PURCHASES,
        accessorKey: TOTAL_PURCHASES_ACCESS_KEY,
        enableColumnFilter: false,
      },
      {
        header: LAST_PURCHASE,
        accessorKey: LAST_PURCHASE_ACCESS_KEY,
        cell: (cell: any) =>
          moment(cell?.row?.original?.lastPurchaseDate).format("ll"),
        enableColumnFilter: false,
      },
      {
        header: TOTAL_AMOUNT,
        accessorKey: TOTAL_AMOUNT_ACCESS_KEY,
        enableColumnFilter: false,
      },
    ],
    []
  );

  const fetchTopCustomerData = (payload: any) => {
    setLoader(true);
    listOfTopCustomers(payload)
      .then((res) => {
        if (checkStatusCodeSuccess(res?.statusCode)) {
          setTopCustomerData(res?.data);
        }
      })
      .catch((error) => {
        return error;
      })
      .finally(() => {
        setLoader(false);
        setBtnLoader(false);
      });
  };

  const fetchDashboardStatisticsData = (payload: any) => {
    setLoader(true);
    dashboardStatistics(payload)
      .then((res) => {
        if (checkStatusCodeSuccess(res?.statusCode)) {
          setTotalOrder(res?.data?.totalOrders);
          setTotalQuantity(res?.data?.totalOrderItemQuantity);
          setTotalCustomer(res?.data?.totalCustomers);
          setTotalProducts(res?.data?.totalProducts);
        }
      })
      .catch((error) => {
        return error;
      })
      .finally(() => {
        setLoader(false);
        setBtnLoader(false);
      });
  };

  const fetchChartData = (payload: any) => {
    setLoader(true);
    graphOfStatistics(payload)
      .then((res) => {
        if (checkStatusCodeSuccess(res?.statusCode)) {
          setChartData(res?.data);
        }
      })
      .catch((error) => {
        return error;
      })
      .finally(() => {
        setLoader(false);
      });
  };

  //for future
  // useEffect(() => {
  //   fetchDashboardStatisticsData({});
  //   fetchTopCustomerData({});
  //   fetchChartData({});
  // }, []);

  return (
    <div className="page-content">
      <div className="flex-grow-1 d-flex justify-content-between align-items-center mx-3">
        <div className="d-flex flex-column justify-content-center mt-2">
          <h4 className="fs-16 mb-1">{getGreeting()}</h4>
          <p className="text-muted mb-0">
            Here's what's happening with your inventory today.
          </p>
        </div>

        {/* for future */}
        {/* <div>
          <div className=" d-flex align-items-center">
            <div className="me-2">
              <BaseInput
                name="startDate"
                type="date"
                placeholder="Start Date"
                onChange={formik.handleChange}
                value={formik.values.startDate}
              />
            </div>
            <div className="me-2">
              <BaseInput
                name="endDate"
                type="date"
                placeholder="End Date"
                onChange={formik.handleChange}
                value={formik.values.endDate}
              />
            </div>
            <BaseButton
              className="btn btn-success me-2"
              onClick={formik.handleSubmit}
              loader={btnLoader}
            >
              {submitLabel}
            </BaseButton>
            <BaseButton className="btn btn-danger" onClick={handleClear}>
              {CLEAR_LABEL}
            </BaseButton>
          </div>
        </div> */}
      </div>

      {/* card view */}
      {/* for future */}
      {/* <div className="row h-100 mt-4">
        <div className="col-lg-3 col-md-6">
          <div className="card card-animate h-95">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="avatar-sm flex-shrink-0">
                  <span className="avatar-title bg-light text-primary rounded-circle shadow fs-3">
                    <i className="mdi mdi-cart align-middle" />
                  </span>
                </div>
                <div className="flex-grow-1 ms-3">
                  <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">
                    {TOTAL_ORDER_LABEL}
                  </p>
                  <h4 className="mb-0">
                    <span className="counter-value" data-target={409}>
                      {totalOrder}
                    </span>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-md-6">
          <div className="card card-animate">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="avatar-sm flex-shrink-0">
                  <span className="avatar-title bg-light text-primary rounded-circle shadow fs-3">
                    <i className="mdi mdi-clipboard-list align-middle" />
                  </span>
                </div>
                <div className="flex-grow-1 ms-3">
                  <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">
                    {TOTAL_QUANTITY_LABEL}
                  </p>
                  <h4 className="mb-0">
                    <span className="counter-value" data-target={1200}>
                      {totalQuantity}
                    </span>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-md-6">
          <div className="card card-animate">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="avatar-sm flex-shrink-0">
                  <span className="avatar-title bg-light text-primary rounded-circle shadow fs-3">
                    <i className="mdi mdi-account-group align-middle" />
                  </span>
                </div>
                <div className="flex-grow-1 ms-3">
                  <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">
                    {TOTAL_CUSTOMER_LABEL}
                  </p>
                  <h4 className="mb-0">
                    <span className="counter-value" data-target={353}>
                      {totalCustomer}
                    </span>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-3 col-md-6">
          <div className="card card-animate">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="avatar-sm flex-shrink-0">
                  <span className="avatar-title bg-light text-primary rounded-circle shadow fs-3">
                    <i className="mdi mdi-package align-middle" />
                  </span>
                </div>
                <div className="flex-grow-1 ms-3">
                  <p className="text-uppercase fw-semibold fs-12 text-muted mb-1">
                    {TOTAL_PRODUCTS_LABEL}
                  </p>
                  <h4 className="mb-0">
                    <span className="counter-value" data-target={353}>
                      {totalProducts}
                    </span>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* top customer list */}
      {/* for future */}
      {/* <div className="row">
        <div className="col-xl-8">
          <div className="card">
            <div className="card-header align-items-center d-flex">
              <h4 className="card-title mb-0 flex-grow-1">
                {TOP_CUSTOMER_LABEL}
              </h4>
            </div>
            <div className="card-body">
              {loader || topCustomerData.length > 0 ? (
                <TableContainer
                  customPageSize={customPageSize}
                  setCustomPageSize={setCustomPageSize}
                  isGlobalFilter={false}
                  columns={topCustomerColumns}
                  data={topCustomerData || []}
                  tableClass="table bg-white"
                  manualPagination={false}
                  manualFiltering={false}
                  tableLoader={loader}
                  hasManualPagination={false}
                  currentPage={1}
                  setCurrentPage={setCurrentPage}
                  totalPages={totalPages}
                  totalRecords={totalRecords}
                  totalNumberOfRows={totalNumberOfRows}
                  fetchData={() => {}}
                  fetchSortingData={() => {}}
                />
              ) : (
                <div className="py-4 text-center">
                  <div>
                    <span className="fs-1 text-success">
                      <RiSearchLine />
                    </span>
                  </div>
                  <div className="mt-4">
                    <h5>{notFound.dataNotFound}</h5>
                    <p className="text-muted">{notFound.thereIsNoDataFound}</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-xl-4">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title mb-0">Statistics Pie Chart</h4>
            </div>

            <div className="card-body">
              <StatisticsCharts dataColors='["--vz-success", "--vz-info","--vz-warning"]' />
            </div>
          </div>
        </div>
      </div> */}

      {/* for future */}
      {/* <div className="row">
        <div className="col-12">
          <Card>
            <CardHeader className="border-0 align-items-center d-flex">
              <h4 className="card-title mb-0 flex-grow-1">Sales By Product</h4>
            </CardHeader>

            <CardHeader className="p-0 border-0 bg-light-subtle">
              <Row className="g-0 text-center">
                <Col xs={8} sm={4}>
                  <div className="p-3 border border-dashed border-start-0">
                    <h5 className="mb-1">
                      <CountUp
                        start={0}
                        end={7585}
                        duration={3}
                        separator=","
                      />
                    </h5>
                    <p className="text-muted mb-0">Orders</p>
                  </div>
                </Col>
                <Col xs={8} sm={4}>
                  <div className="p-3 border border-dashed border-start-0">
                    <h5 className="mb-1">
                      <CountUp
                        suffix="k"
                        start={0}
                        decimals={2}
                        end={22.89}
                        duration={3}
                      />
                    </h5>
                    <p className="text-muted mb-0">Earnings</p>
                  </div>
                </Col>
                <Col xs={8} sm={4}>
                  <div className="p-3 border border-dashed border-start-0">
                    <h5 className="mb-1">
                      <CountUp start={0} end={367} duration={3} />
                    </h5>
                    <p className="text-muted mb-0">Refunds</p>
                  </div>
                </Col>
              </Row>
            </CardHeader>

            <CardBody className="p-0 pb-2">
              <div className="w-100">
                <div dir="ltr">
                  <TopCustomersChart
                    seriesData={chartData}
                    dataColors='["--vz-primary", "--vz-danger"]'
                  />
                </div>
              </div>
            </CardBody>
          </Card>

          <Card>
            <CardHeader className="border-0 align-items-center d-flex">
              <h4 className="card-title mb-0 flex-grow-1">Graph of Earnings</h4>
            </CardHeader>

            <CardBody className="p-0 pb-2">
              <div className="w-100">
                <div dir="ltr">
                  <TopCustomersChart
                    earnings
                    seriesData={chartData}
                    dataColors='["--vz-success"]'
                  />
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div> */}
    </div>
  );
};

export default DashboardCrm;
